<template>
  <div>
    <v-card class="px-6 py-10">
      <div v-if="!activationCode">
        <h4>ورود به حساب</h4>
        <!-- <p class="red-text mt-6" v-if="['aparat', 'telegram'].includes(ref)">
          *برای دربافت پانصد هزار ریال اعتبار هدیه همین الان وارد شو*
        </p> -->
        <p class="mainFont--text mt-6">
          سلام! لطفا جهت ورود شماره موبایل خود را وارد کنید:
        </p>
        <v-text-field
          outlined
          label="شماره موبایل"
          placeholder="*********09"
          color="shopPrimary"
          hideDetails
          v-model="mobile"
          @keyup.enter="sendCode()"
          pattern="\d*"
        ></v-text-field>

        <v-btn
          class="shopPrimary white--text mt-3"
          :disabled="mobile.length != 11"
          height="48"
          block
          @click="sendCode()"
          :loading="sending"
        >
          <template v-slot:loader>
            <div>
              <looping-rhombuses-spinner
                :animation-duration="2500"
                :rhombus-size="10"
                color="#fff"
              />
            </div>
          </template>
          ارسال کد تایید
        </v-btn>
      </div>

      <div v-else>
        <div
          @click="
            activationCode = false;
            countdown = 0;
          "
          class="text-left pointer"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </div>

        <p class="mainFont--text">
          کد ارسال شده به شماره {{ mobile }} را وارد نمایید:
        </p>
        <div class="text-center">
          <PincodeInput
            v-model="code"
            class="mb-4"
            dir="ltr"
            :class="incorrectCode ? 'incorrect-code' : ''"
            :length="4"
            autofocus
            @input="login()"
          />
        </div>

        <div class="mb-4 text-center mainFont--text fs-xsmall" v-if="!checking">
          <span v-if="countdown != 0">{{
            toHHMMSS(countdown) + " تا ارسال مجدد کد تایید"
          }}</span>
          <span v-else @click="sendCode()" class="shopPrimary--text pointer">
            ارسال مجدد کد تایید
            <v-icon color="shopPrimary" class="ms-1" small
              >mdi-chevron-left</v-icon
            >
          </span>
        </div>

        <div style="width: fit-content" class="mx-auto d-flex" v-else>
          <half-circle-spinner
            :animation-duration="1000"
            :size="17"
            color="#7c4dff"
          />
          <span class="ps-2 fs-small shopPrimary--text">در حال بررسی کد</span>
        </div>

        <v-btn
          class="shopPrimary white--text mt-3"
          height="48"
          block
          @click="
            activationCode = false;
            countdown = 0;
          "
          ><v-icon class="light-icon me-2">$Edit</v-icon> ویرایش شماره موبایل
        </v-btn>
      </div>
    </v-card>
  </div>
</template>
<script>
import PincodeInput from "vue-pincode-input";
import { LoopingRhombusesSpinner, HalfCircleSpinner } from "epic-spinners";
import Axios from "axios";

export default {
  components: {
    PincodeInput,
    HalfCircleSpinner,
    LoopingRhombusesSpinner,
  },
  data() {
    return {
      code: "",
      mobile: "",
      countdown: 120,
      cartId: "",
      sending: false,
      checking: false,
      incorrectCode: false,
      activationCode: false,
      ref: "",
    };
  },

  mounted() {
    this.getRefFromUrl();
  },

  methods: {
    getRefFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      this.ref = urlParams.get("ref")
        ? urlParams.get("ref")
        : localStorage.getItem("ref")
        ? localStorage.getItem("ref")
        : "";
    },
    convertNumbers2English(string) {
      try {
        let myString = String(string);
        myString = myString
          .replaceAll(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
          .replaceAll(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
          .replaceAll(/\D/g, "");
        return myString;
      } catch (error) {
        return "";
      }
    },
    sendCode() {
      const englishmobile = this.convertNumbers2English(this.mobile);
      this.sending = true;
      Axios.post(this.baseUrl + "/onlineShop/auth/getCode", {
        mobile: englishmobile,
        ref: this.ref,
      })
        .then((res) => {
          if (res.status == 200) {
            this.code = "";
            this.incorrectCode = false;
            this.checking = false;
            this.countdown = 120;
            this.activationCode = true;
            this.countDownTimer();
            this.sending = false;
            this.toast(res.data, "success");
            localStorage.setItem("ref", "");
          }
        })
        .catch((err) => {
          this.sending = false;

          this.toast(err.response.data, "error");
        });
    },
    login() {
      const englishmobile = this.convertNumbers2English(this.mobile);
      const englishcode = this.convertNumbers2English(this.code);
      if (englishcode.length == 4) {
        this.checking = true;
        Axios.post(this.baseUrl + "/onlineShop/auth/entrance", {
          mobile: englishmobile,
          code: englishcode,
        })
          .then((res) => {
            if (res.status == 200) {
              localStorage.setItem("shopToken", res.data.token);
              localStorage.setItem("mobile", res.data.mobile);
              localStorage.setItem("name", res.data.name);
              localStorage.setItem("id", res.data.id);
              localStorage.setItem("address", res.data.address);
              localStorage.setItem("postalCode", res.data.postalCode);
              localStorage.setItem("cartId", res.data.cartId);
              if (res.data.discountData) {
                localStorage.setItem("hasDiscount", true);
                localStorage.setItem(
                  "discountName",
                  res.data.discountData.name
                );
                localStorage.setItem(
                  "discountAmount",
                  res.data.discountData.amount
                );
              } else {
                localStorage.setItem("hasDiscount", false);
              }
              this.cartId = res.data.cartId;
              this.$store.dispatch("getCartData", {
                cartId: this.cartId,
              });
              if (!res.data.nameExistance) {
                this.$router.push("/accountinformation");
              } else {
                const preLoginRoute = localStorage.getItem("preLoginRoute");
                if (preLoginRoute) {
                  this.$router.push(preLoginRoute);
                } else {
                  this.$router.push("/");
                }
                localStorage.removeItem("preLoginRoute");
                window.location.reload();
              }
              this.checking = false;
              this.activationCode = false;
              this.mobile = "";
              this.toast("ورود با موفقیت انجام شد", "success");
              setTimeout(() => {
                this.checking = false;
                this.mobile = "";
              }, 200);
              this.$emit("closeLogin");
            } else if (res.status == 419) {
              this.toast(err.response.data, "error");
            }
          })
          .catch((err) => {
            if (err.response && err.response.status == 401) {
              this.incorrectCode = true;
              setTimeout(() => {
                this.code = "";
                this.incorrectCode = false;
              }, 2000);
            }
            this.checking = false;
            this.toast(err.response.data, "error");
          });
      }
    },
    countDownTimer() {
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.countdown = 0;
      }
    },
    toHHMMSS(value) {
      var sec_num = parseInt(value, 10);
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return minutes + ":" + seconds;
    },
  },
};
</script>

<style lang="scss">
.red-text {
  color: red;
}
</style>
